<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-4 col-sm-12">
                <div class="card card-hover">
                    <div class="card-body row">
                        <div class="col-3">
                            <i class="fa fa-5x text-success fa-warehouse"/>
                        </div>
                        <div class="col-9">
                            <h4 class="card-title text-right">Warehouses</h4>
                            <h2 class="card-title font-bold text-success m-t-10 m-b-10 text-right">{{warehouses.length}}</h2>
                            <h5 class="card-subtitle m-b-0 text-right">No of warehouses in marketplace</h5>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-12">
                <div class="card card-hover">
                    <div class="card-body row">
                        <div class="col-3">
                            <i class="fa fa-5x text-success fa-apple-alt"/>
                        </div>
                        <div class="col-9">
                            <h4 class="card-title text-right">Goods</h4>
                            <h2 class="font-bold card-title text-success m-t-10 m-b-10 text-right">{{inventory.length}}</h2>
                            <h5 class="card-subtitle m-b-0 text-right">No of goods in all warehouses</h5>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-12">
                <div class="card card-hover">
                    <div class="card-body row">
                        <div class="col-3">
                            <i class="fa fa-5x text-success fa-exchange-alt"/>
                        </div>
                        <div class="col-9">
                            <h4 class="card-title text-right">Activity</h4>
                            <h2 class="font-bold card-title text-success m-t-10 m-b-10 text-right">{{totalTransactionCount || 0}}</h2>
                            <h5 class="card-subtitle m-b-0 text-right">No of times goods exchanged</h5>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="card card-blue">
                    <div class="card-header">
                        <h4 class="card-title">Stock</h4>
                        <h5 class="card-subtitle">Current Inventory of Goods</h5>
                    </div>

                    <div class="card-body">
                        <div class="table-responsive">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <div class="col-4">
                                        <multiselect
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :options="invWarehouses"
                                            :searchable="true"
                                            :selectLabel="''"
                                            @search-change="invFilterWarehouses"
                                            :show-no-results="false"
                                            class="form-control multiselect-sm"
                                            id="warehouse"
                                            label="Search Warehouse"
                                            name="customer"
                                            open-direction="bottom"
                                            placeholder="Search Warehouses"
                                            v-model="invFilter.warehouse">
                                            <template slot="singleLabel" slot-scope="props">
                                                {{props.option.name}}
                                            </template>
                                            <template slot="option" slot-scope="props">
                                                <div class="option__desc">
                                                    <h5>{{ props.option.name }}</h5>
                                                    <div>{{ props.option.description }}</div>
                                                </div>
                                            </template>
                                            <span slot="noResult">Purchaser not found</span>
                                        </multiselect>
                                    </div>

                                    <div class="col-3">
                                        <multiselect
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :options="invGoods"
                                            :searchable="true"
                                            :selectLabel="''"
                                            :show-no-results="false"
                                            class="form-control multiselect-sm"
                                            id="good"
                                            @search-change="invFilterGoods"
                                            label="Search Good"
                                            name="customer"
                                            open-direction="bottom"
                                            placeholder="Search Good"
                                            v-model="invFilter.good">
                                            <template slot="singleLabel" slot-scope="props">
                                                {{props.option.commodity_name}}
                                            </template>
                                            <template slot="option" slot-scope="props">
                                                <div class="option__desc">
                                                    <h5>{{ props.option.commodity_name }}</h5>

                                                </div>
                                            </template>
                                            <span slot="noResult">Good not found</span>
                                        </multiselect>
                                    </div>

                                    <div class="col-2">
                                        <div class="input-group">
                                            <input type="number" placeholder="Quantity" class="form-control" v-model="invFilter.quantity">
                                            <select type="number" v-model="invFilter.comp" class="form-control input-append" style="max-width: 60px;">
                                                <option value="=">=</option>
                                                <option value=">">&gt;</option>
                                                <option value="<">&lt;</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-2">
                                        <div class="btn-group">
                                            <button @click="getInventories(1)" class="btn btn-light btn-outline-success font-weight-bold" type="button">
                                                <i class="fa fa-search"/> Go!
                                            </button>
                                            <button @click="resetInv()" class="btn btn-light btn-outline-secondary btn-arrange font-weight-bold" type="button">
                                                <i class="fa fa-undo"/> Reset
                                            </button>
                                        </div>
                                    </div>

                                    <div class="col-1 text-right">
                                        <span class="fa-sm fa-stack fa-1x ml-auto text-muted" v-if="exporting" title="Exporting, please wait ...">
                                          <i class="fa fa-circle-notch fa-stack-2x fa-spin"></i>
                                          <i class="fa fa-sm fa-file-excel fa-stack-1x"></i>
                                        </span>
                                        <button aria-expanded="false" aria-haspopup="true" class="btn waves-effect waves-light btn-outline-info"
                                                data-toggle="dropdown" title="Operations">
                                            <i class="fa fa-grip-vertical"/>
                                        </button>
                                        <div class="dropdown-menu">
                                            <a @click="exportStockAsExcel()" class="dropdown-item" href="javascript:void(0)">
                                                <i class="fa fa-file-excel"/> Export
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <table class="table no-wrap v-top" v-if="inventories.length >0">
                                <thead>
                                <tr class="border-0 bg-light">
                                    <th class="border-0"><h6>Warehouse</h6></th>
                                    <th class="border-0"><h6>Good</h6></th>
                                    <th class="border-0"><h6>Variety</h6></th>
                                    <th class="border-0"><h6>Native Name</h6></th>
                                    <th class="border-0"><h6>Category</h6></th>
                                    <th class="border-0 text-right"><h6>Available Quantity</h6></th>
                                    <th class="border-0 text-center"><h6>Unit</h6></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(t, index) in inventories">
                                    <td>
                                        <router-link :to="{ name: 'viewmarketplacewarehouse', params: {warehouseid: t.warehouse_id}}" v-if="t.warehouse_id">
                                            {{t.warehouse_name}}
                                        </router-link>
                                        <span v-else>All Warehouses</span>
                                    </td>
                                    <td>{{t.name}}</td>
                                    <td>{{t.variety}}</td>
                                    <td>{{t.native}}</td>
                                    <td><goods-services-category :category="t.category"/></td>
                                    <td class="text-right">{{t.quantity | unitFix(2)}}</td>
                                    <td class="text-center">{{t.unit}}</td>
                                </tr>
                                </tbody>
                            </table>
                            <template v-else>
                                <h4 class="card-title text-muted text-center m-t-30">No records found.</h4>
                                <h5 class="card-title text-muted text-center m-b-30">Change search criteria and try again</h5>
                            </template>
                        </div>
                    </div>

                    <div class="card-footer" v-if="inventories.length>0">
                        <div class="row">
                            <div class="col-6">
                                <div class="row">
                                    <label class="col-form-label p-l-10" for="records">Display</label>
                                    <div class="col-auto p-t-5">
                                        <select @change="perPageRecordChangeInv()" aria-controls="lang_opt" class="form-control form-control-sm" name="lang_opt_length"
                                                v-model="perPageInv">
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                    <label class="col-form-label" for="records">Records per page</label>
                                </div>
                            </div>

                            <div class="col-6">
                                <paginate
                                    :click-handler="pageHandlerInv"
                                    :container-class="'pagination float-right mb-0'"
                                    :margin-pages="2"
                                    :next-class="'page-link'"
                                    :next-text="'Next'"
                                    :page-class="'page-link'"
                                    :page-count=pageCountInv
                                    :page-range="3"
                                    :prev-class="'page-link'"
                                    :prev-text="'Prev'">
                                </paginate>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="card card-blue">
                    <div class="card-header">
                        <h4 class="card-title">Logs</h4>
                        <h5 class="card-subtitle">Recent Goods Transactions</h5>
                    </div>

                    <div class="card-body">
                        <div class="table-responsive">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <div class="col-md-3 col-sm-12">
                                        <input type="text" class="form-control" v-model="txnFilter.batch" placeholder="Batch Number">
                                    </div>

                                    <div class="col-md-3 col-sm-12">
                                        <multiselect
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :options="txnWarehouses"
                                            :searchable="true"
                                            :selectLabel="''"
                                            @search-change="txnFilterWarehouses"
                                            :show-no-results="false"
                                            class="form-control multiselect-sm"
                                            id="warehousetxn"
                                            label="From Warehouse"
                                            name="customer"
                                            open-direction="bottom"
                                            placeholder="From Warehouses"
                                            v-model="txnFilter.from_warehouse">
                                            <template slot="singleLabel" slot-scope="props">
                                                {{props.option.name}}
                                            </template>
                                            <template slot="option" slot-scope="props">
                                                <div class="option__desc">
                                                    <h5>{{ props.option.name }}</h5>
                                                    <div>{{ props.option.description }}</div>
                                                </div>
                                            </template>
                                            <span slot="noResult">Purchaser not found</span>
                                        </multiselect>
                                    </div>

                                    <div class="col-md-3 col-sm-12">
                                        <multiselect
                                                :clear-on-select="false"
                                                :close-on-select="true"
                                                :hide-selected="true"
                                                :internal-search="false"
                                                :options="txnWarehouses"
                                                :searchable="true"
                                                :selectLabel="''"
                                                @search-change="txnFilterWarehouses"
                                                :show-no-results="false"
                                                class="form-control multiselect-sm"
                                                id="to_warehousetxn"
                                                label="To Warehouse"
                                                name="customer"
                                                open-direction="bottom"
                                                placeholder="To Warehouses"
                                                v-model="txnFilter.to_warehouse">
                                            <template slot="singleLabel" slot-scope="props">
                                                {{props.option.name}}
                                            </template>
                                            <template slot="option" slot-scope="props">
                                                <div class="option__desc">
                                                    <h5>{{ props.option.name }}</h5>
                                                    <div>{{ props.option.description }}</div>
                                                </div>
                                            </template>
                                            <span slot="noResult">Purchaser not found</span>
                                        </multiselect>
                                    </div>

                                    <div class="col-md-3 col-sm-12">
                                        <multiselect
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :options="txnGoods"
                                            :searchable="true"
                                            :selectLabel="''"
                                            :show-no-results="false"
                                            class="form-control multiselect-sm"
                                            id="goodtxn"
                                            @search-change="txnFilterGoods"
                                            label="Search Good"
                                            name="customer"
                                            open-direction="bottom"
                                            placeholder="Search Good"
                                            v-model="txnFilter.good">
                                            <template slot="singleLabel" slot-scope="props">
                                                {{props.option.commodity_name}}
                                            </template>
                                            <template slot="option" slot-scope="props">
                                                <div class="option__desc">
                                                    <h5>{{ props.option.commodity_name }}</h5>

                                                </div>
                                            </template>
                                            <span slot="noResult">Good not found</span>
                                        </multiselect>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div class="col-md-3 col-sm-12">
                                        <multiselect class="form-control multiselect-sm"
                                                     placeholder="Select Type"
                                                     :options="['Add','Receive','Deduct','Transfer','Challan']"
                                                     v-model="txnFilter.type">
                                        </multiselect>
                                    </div>
                                    <div class="col-md-2 col-sm-12">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <button class="btn btn-light waves-effect border"
                                                        data-toggle="dropdown"
                                                        aria-haspopup="true"
                                                        aria-expanded="false">
                                                    {{txnFilter.comp}}
                                                </button>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                    <a class="dropdown-item" href="#" @click="txnFilter.comp = '='">= Equals To</a>
                                                    <a class="dropdown-item" href="#" @click="txnFilter.comp = '>'">&lt; Greater Than</a>
                                                    <a class="dropdown-item" href="#" @click="txnFilter.comp = '<'">&gt; Less Than</a>
                                                </div>
                                            </div>
                                            <input type="number" placeholder="Quantity" class="form-control" v-model="txnFilter.quantity">
                                        </div>
                                    </div>

                                    <div class="col-md-2 col-sm-12">
                                        <input type="text" id="startdate" placeholder="Start Date" class="form-control"/>
                                    </div>

                                    <div class="col-md-2 col-sm-12">
                                        <input type="text" id="enddate" placeholder="End Date" class="form-control"/>
                                    </div>

                                    <div class="col-md-2 col-sm-12">
                                        <div class="btn-group">
                                            <button @click="getTransactions(1)" class="btn btn-light btn-outline-success font-weight-bold" type="button">
                                                <i class="fa fa-search"/> Go!
                                            </button>
                                            <button @click="reset()" class="btn btn-light btn-outline-secondary btn-arrange font-weight-bold" type="button">
                                                <i class="fa fa-undo"/> Reset
                                            </button>
                                        </div>
                                    </div>

                                    <div class="col-md-1 col-sm-12 text-right">
                                        <span class="fa-sm fa-stack fa-1x ml-auto text-muted" v-if="exportingInv" title="Exporting, please wait ...">
                                          <i class="fa fa-circle-notch fa-stack-2x fa-spin"></i>
                                          <i class="fa fa-sm fa-file-excel fa-stack-1x"></i>
                                        </span>
                                        <button aria-expanded="false" aria-haspopup="true" class="btn waves-effect waves-light btn-outline-info"
                                                data-toggle="dropdown" title="Operations">
                                            <i class="fa fa-grip-vertical"/>
                                        </button>
                                        <div class="dropdown-menu">
                                            <a @click="exportInvAsExcel()" class="dropdown-item" href="javascript:void(0)">
                                                <i class="fa fa-file-excel"/> Export
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <table class="table no-wrap v-top" v-if="transactions.length>0">
                                <thead>
                                <tr class="border-0 bg-light">
                                    <th class="border-0"><h6>Batch No</h6></th>
                                    <th class="border-0"><h6>Warehouse</h6></th>
                                    <th class="border-0"><h6>Good</h6></th>
                                    <th class="border-0 text-right"><h6>Quantity</h6></th>
                                    <th class="border-0 text-center"><h6>Type</h6></th>
                                    <th class="border-0"><h6>Timestamp</h6></th>
                                    <th class="border-0 text-center"><h6>Action</h6></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(t, index) in transactions">
                                    <td>{{t.number}}</td>
                                    <td>
                                        <router-link :to="{ name: 'viewmarketplacewarehouse', params: {warehouseid: t.warehouse_id}}">{{t.warehouse_name}}</router-link>
                                    </td>
                                    <td>{{t.name}} - {{t.variety}}</td>
                                    <td class="text-right">{{t.quantity < 0 ? -1 * t.quantity : t.quantity | unitFix(2)}} {{t.unit}}</td>
                                    <td class="text-center">
                                        <warehouse-transaction-status :transaction="t"/>
                                        <!--                                        <template  v-if="t.quantity >=0">-->
                                        <!--                                            <span class="label label-light-green font-weight-bold" v-if="t.from">-->
                                        <!--                                                <i class="mdi mdi-call-received"/> RCV-->
                                        <!--                                            </span>-->
                                        <!--                                            <span class="label label-dark-green font-weight-bold" v-else>ADD</span>-->
                                        <!--                                        </template>-->
                                        <!--                                        <template v-else>-->
                                        <!--                                            <span class="label label-brown font-weight-bold" v-if="t.to">-->
                                        <!--                                                TRF-->
                                        <!--                                            </span>-->
                                        <!--                                            <span class="label label-danger font-weight-bold" v-else>DED</span>-->
                                        <!--                                        </template>-->
                                    </td>
                                    <td>{{t.created_at | long}}</td>
                                    <td class="text-center pt-2 pb-0">
                                        <div class="btn-group">
                                            <button class="btn btn-sm btn-outline-info mb-0"
                                                    data-toggle="popover"
                                                    data-trigger="focus"
                                                    data-title="Remarks"
                                                    data-animation="true"
                                                    :data-content="t.ref"
                                                    :title="`Remarks By ${t.first_name} ${t.last_name}`">
                                                <i class="fa fa-2x fa-comment-dots"/>
                                            </button>
                                            <button aria-expanded="false" aria-haspopup="true" class="btn waves-effect waves-light btn-outline-info"
                                                    data-toggle="dropdown" title="Options" style="border-top-right-radius: 5px;border-bottom-right-radius: 5px;">
                                                <i class="fa fa-ellipsis-v"/>
                                            </button>
                                            <div class="dropdown-menu">
                                                <router-link v-if="t.challan_id"
                                                             :to="{name: 'marketplaceviewchallan', params : { challanid: t.challan_id}}"
                                                             class="dropdown-item"
                                                             href="javascript:void(0)">View Challan
                                                </router-link>
                                                <a href="javascript:void(0)"  class="dropdown-item" v-else>
                                                    No Options
                                                </a>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <template v-else>
                                <h4 class="card-title text-muted text-center m-t-30">No records found.</h4>
                                <h5 class="card-title text-muted text-center m-b-30">Change search criteria and try again</h5>
                            </template>
                        </div>
                    </div>

                    <div class="card-footer" v-if="transactions.length>0">
                        <div class="row">
                            <div class="col-6">
                                <div class="row">
                                    <label class="col-form-label p-l-10" for="records">Display</label>
                                    <div class="col-auto p-t-5">
                                        <select @change="perPageRecordChange()" aria-controls="lang_opt" class="form-control form-control-sm" id="records" name="lang_opt_length"
                                                v-model="perPage">
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                    <label class="col-form-label" for="records">Records per page</label>
                                </div>
                            </div>
                            <div class="col-6">
                                <paginate
                                    :click-handler="pageHandler"
                                    :container-class="'pagination float-right mb-0'"
                                    :margin-pages="2"
                                    :next-class="'page-link'"
                                    :next-text="'Next'"
                                    :page-class="'page-link'"
                                    :page-count=pageCount
                                    :page-range="3"
                                    :prev-class="'page-link'"
                                    :prev-text="'Prev'">
                                </paginate>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Paginate from "vuejs-paginate";
import {mapGetters} from "vuex";
import _ from "lodash";
import Multiselect from 'vue-multiselect';
import WarehouseTransactionStatus from "./MarWarehouseTransactionStatus";
import XLSX from "xlsx";
import GoodsServicesCategory from "../../express/purchases/goods-services/GoodsServicesCategory";

export default {
    name: "Dashboard",
    props: ["marketplaceid"],
    components: {GoodsServicesCategory, Multiselect, Paginate, WarehouseTransactionStatus},
    computed: {
        ...mapGetters(["currentUser", "currentOrg"])
    },
    data() {
        return {
            inventory: [],
            warehouses: [],
            goods: [],
            invWarehouses: [],
            invGoods: [],
            txnWarehouses: [],
            txnGoods: [],
            good: null,
            transactions: [],
            totalTransactionCount: null,
            pageCount: 1,
            total: 0,
            perPage: 5,
            exporting: false,
            inventories: [],
            pageCountInv: 1,
            totalInv: 0,
            perPageInv: 5,
            exportingInv: false,
            invFilter: {
                warehouse: null,
                good: null,
                quantity: null,
                comp: '='
            },
            txnFilter: {
                batch: null,
                warehouse: null,
                from_warehouse: null,
                to_warehouse: null,
                good: null,
                quantity: null,
                comp: '=',
                startdate: null,
                enddate: null,
                type: null
            }
        }
    },
    mounted() {
        let self = this;
        $(function() {
            $('#startdate')
                .datepicker({
                    format: "dd/mm/yyyy",
                    autoclose: true
                })
                .on('changeDate', (e) => {
                    let parts = e.target.value.split('/');
                    if(parts.length > 0) {
                        self.txnFilter.startdate = `${parts[2]}-${parts[1]}-${parts[0]}`;
                    } else {
                        self.txnFilter.startdate = null;
                    }
                });

            $('#enddate')
                .datepicker({
                    format: "dd/mm/yyyy",
                    autoclose: true
                })
                .on('changeDate', (e) => {
                    let parts = e.target.value.split('/');
                    if(parts.length > 0) {
                        self.txnFilter.enddate = `${parts[2]}-${parts[1]}-${parts[0]}`;
                    } else {
                        self.txnFilter.enddate = null;
                    }
                });
        });
        this.init()
    },
    methods: {
        async init() {
            try {
                $(".preloader").fadeIn();
                await Promise.all([
                    this.getWarehouses(),
                    this.getInventory(),
                    this.getTransactions(1)
                ]);
            } catch(e) {
            } finally {
                $(".preloader").fadeOut();
            }
        },
        async getInventory() {
            let reply      = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/inventory`);
            this.inventory = reply.data;
            this.goods     = []
            this.inventory.forEach(inv => {
                this.goods.push({
                    id: inv.id,
                    name: inv.name,
                    description: inv.description
                });
            })
            await this.getInventories(1);
        },
        async getTransactions(page) {
            let filter = {};

            if(this.txnFilter.batch) {
                filter.batch = this.txnFilter.batch;
            }

            if(this.txnFilter.warehouse) {
                filter.warehouseid = this.txnFilter.warehouse.id;
            }

            if(this.txnFilter.from_warehouse) {
                filter.warehouseid = this.txnFilter.from_warehouse.id;
            }

            if(this.txnFilter.to_warehouse) {
                filter.warehouseid = this.txnFilter.to_warehouse.id;
            }

            if(this.txnFilter.good) {
                filter.goodid = this.txnFilter.good.commodity_id;
            }

            if(this.txnFilter.quantity) {
                filter.quantity = this.txnFilter.quantity;
                filter.comp     = this.txnFilter.comp;
            }

            if(this.txnFilter.startdate) {
                filter.start= this.txnFilter.startdate;
            }

            if(this.txnFilter.enddate) {
                filter.end = this.txnFilter.enddate;
            }

            if(this.txnFilter.type) {
                filter.type = this.txnFilter.type;
            }

            let reply = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/inventory/transactions`, {
                params: {
                    page: page,
                    perPage: this.perPage,
                    ...filter
                }
            });

            if(!this.totalTransactionCount) {
                this.totalTransactionCount = reply.data.total
            }
            this.total        = reply.data.total;
            this.transactions = reply.data.transactions;

            this.setPageCount();
            $(function() {
                $('[data-toggle="popover"]').popover({
                    show: function() {
                        $(this).fadeIn('slow');
                    }
                })
            });
        },
        async getInventories(page) {
            let inventories = this.inventory;

            if(this.invFilter.warehouse) {
                let reply   = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/inventory/warehouses/${this.invFilter.warehouse.id}`);
                inventories = reply.data.inventory;
            }

            if(this.invFilter.good) {
                inventories = _.filter(inventories, (e) => {
                    return e.id === this.invFilter.good.commodity_id;
                })
            }

            if(this.invFilter.quantity) {
                if(this.invFilter.comp === '=') {
                    inventories = _.filter(inventories, (e) => {
                        return Number(e.quantity) === Number(this.invFilter.quantity);
                    })
                } else if(this.invFilter.comp === '>') {
                    inventories = _.filter(inventories, (e) => {
                        return Number(e.quantity) > Number(this.invFilter.quantity);
                    })
                } else {
                    inventories = _.filter(inventories, (e) => {
                        return Number(e.quantity) < Number(this.invFilter.quantity);
                    })
                }
            }

            this.totalInv    = inventories.length;
            let start        = (page - 1) * this.perPageInv;
            let end          = start + this.perPageInv;
            this.inventories = inventories.slice(start, end);
            this.setPageCountInv();
        },
        pageHandler(pageNum) {
            this.getTransactions(pageNum);
        },
        setPageCount() {
            this.pageCount = this.total <= this.perPage ? 1 : Math.ceil(this.total / this.perPage);
        },
        perPageRecordChange() {
            if(this.isFiltered) {
                this.getTransactions(1);
            } else {
                this.getTransactions(1);
            }
        },
        pageHandlerInv(pageNum) {
            this.getInventories(pageNum);
        },
        setPageCountInv() {
            this.pageCountInv = this.totalInv <= this.perPageInv ? 1 : Math.ceil(this.totalInv / this.perPageInv);
        },
        perPageRecordChangeInv() {
            if(this.isFiltered) {
                this.getInventories(1);
            } else {
                this.getInventories(1);
            }
        },
        async reset() {
            this.txnFilter = {
                batch: null,
                warehouse: null,
                good: null,
                quantity: null,
                comp: '=',
                startdate: null,
                enddate: null,
                type: null
            };
            await this.getTransactions(1);
        },
        async resetInv() {
            this.invFilter = {
                warehouse: null,
                good: null,
                quantity: null,
                comp: '='
            };
            await this.getInventory();
        },
        async getWarehouses() {
            let reply = await this.$http
                .get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses`, {
                    params: {
                        page: 1,
                        perPage: 100
                    }
                });

            this.warehouses = reply.data.warehouses;
        },
        async invFilterWarehouses(search) {
            let reply          = await this.$http
                .get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses`, {
                    params: {
                        search
                    }
                });
            this.invWarehouses = reply.data.warehouses;
        },
        async invFilterGoods(search) {
            this.isLoading = true;
            let reply      = await this.$http.get("/marketplaces/" + this.marketplaceid + "/commodities/search", {
                params: {
                    search
                }
            });
            this.invGoods  = reply.data;
        },
        async txnFilterWarehouses(search) {
            let reply          = await this.$http
                .get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses`, {
                    params: {
                        search
                    }
                });
            this.txnWarehouses = reply.data.warehouses;
        },
        async txnFilterGoods(search) {
            this.isLoading = true;
            let reply      = await this.$http.get("/marketplaces/" + this.marketplaceid + "/commodities/search", {
                params: {
                    search
                }
            });
            this.txnGoods  = reply.data;
        },
        async exportStockAsExcel() {
            try {
                this.exporting = true;

                let inventories = this.inventory;

                if(this.invFilter.warehouse) {
                    let reply   = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/${this.invFilter.warehouse.id}`);
                    inventories = reply.data.inventory;
                }

                if(this.invFilter.good) {
                    inventories = _.filter(inventories, (e) => {
                        return e.id === this.invFilter.good.id;
                    })
                }

                if(this.invFilter.quantity) {
                    if(this.invFilter.comp === '=') {
                        inventories = _.filter(inventories, (e) => {
                            return Number(e.quantity) === Number(this.invFilter.quantity);
                        })
                    } else if(this.invFilter.comp === '>') {
                        inventories = _.filter(inventories, (e) => {
                            return Number(e.quantity) > Number(this.invFilter.quantity);
                        })
                    } else {
                        inventories = _.filter(inventories, (e) => {
                            return Number(e.quantity) < Number(this.invFilter.quantity);
                        })
                    }
                }

                let _inventories = [];

                inventories.forEach(d => {
                    _inventories.push({
                        "Name": d.name,
                        "Description": d.description,
                        "Quantity": d.quantity,
                        "Unit": d.unit
                    })
                });

                let workbook  = XLSX.utils.book_new();
                let worksheet = XLSX.utils.json_to_sheet(_inventories);
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Inventories');
                XLSX.writeFile(workbook, 'inventories.xlsx');
            } catch(e) {
                console.error(e)
                this.$toastr('error', 'Export failed', 'Failure');
            } finally {
                this.exporting = false;
            }
        },
        async exportInvAsExcel() {
            try {
                this.exportingInv = true;

                let filter = {};

                if(this.txnFilter.batch) {
                    filter.batch = this.txnFilter.batch;
                }

                if(this.txnFilter.warehouse) {
                    filter.warehouseid = this.txnFilter.warehouse.id;
                }

                if(this.txnFilter.good) {
                    filter.goodid = this.txnFilter.good.id;
                }

                if(this.txnFilter.quantity) {
                    filter.quantity = this.txnFilter.quantity;
                    filter.comp     = this.txnFilter.comp;
                }

                if(this.txnFilter.startdate) {
                    filter.start= this.txnFilter.startdate;
                }

                if(this.txnFilter.enddate) {
                    filter.end = this.txnFilter.enddate;
                }

                if(this.txnFilter.type) {
                    filter.type = this.txnFilter.type;
                }

                let reply        = await this.$http
                    .get(`/marketplaces/${this.currentOrg.marketplace_id}/inventory/transactions`, {
                        params: {
                            page: 1,
                            perPage: this.total,
                            ...filter
                        }
                    });
                let data         = reply.data.transactions;
                let transactions = [];
                data.forEach(d => {
                    transactions.push({
                        "Batch": d.number,
                        "Warehouse": d.warehouse_name,
                        "Good": d.name,
                        "Quantity": Math.abs(d.quantity),
                        "Type": d.quantity >= 0 ? 'IN' : 'OUT',
                        "From": d.from,
                        "To": d.to,
                        "Unit": d.unit,
                        "Timestamp": d.created_at,
                        "Reference": d.ref,
                        "Created By": d.email
                    })
                });

                let workbook  = XLSX.utils.book_new();
                let worksheet = XLSX.utils.json_to_sheet(transactions);
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Transactions');
                XLSX.writeFile(workbook, 'transactions.xlsx');
            } catch(e) {
                console.error(e)
                this.$toastr('error', 'Export failed', 'Failure');
            } finally {
                this.exportingInv = false;
            }
        }
    }
}
</script>

<style scoped>

</style>
